import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CreateAppLoadingContainer, CreateAppLoadingGif, CreateAppLoadingText, CreateAppSheetContainer, } from '../styles';
import loadingImg from '../../../images/loading.gif';
import { useSelector } from 'react-redux';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
var CreateAppLoading = function () {
    var _a = useSelector(selectAppCreationFlow), creationType = _a.creationType, loadingMessage = _a.loadingMessage;
    return (_jsx(CreateAppSheetContainer, { children: _jsxs(CreateAppLoadingContainer, { children: [_jsx(CreateAppLoadingGif, { src: loadingImg, alt: "loading" }), creationType === 'TEMPLATE' ? (_jsx(CreateAppLoadingText, { children: loadingMessage })) : (_jsx(CreateAppLoadingText, { children: "Customizing app..." }))] }) }));
};
export default CreateAppLoading;
